/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { ReactComponent as IconInputChecked } from '../../assets/icons/icon_input_checked.svg';
import { ReactComponent as ImageHomeBanner } from '../../assets/images/image_home_banner.svg';
import { ReactComponent as ImageNotFound } from '../../assets/images/image_not_found.svg';
import { ReactComponent as ImageErrorBoundary } from '../../assets/images/image_error_boundary.svg';
import { ReactComponent as ImageCloudBg } from '../../assets/images/image_cloud_bg.svg';
import { ReactComponent as ImageTooltipSolidBg } from '../../assets/images/image_tooltip_popup_solid_bg.svg';
import { ReactComponent as ImageTooltipOutlineBg } from '../../assets/images/image_tooltip_popup_outline_bg.svg';

type GraphicProps = {
  id: string;
  className?: string;
  onClick?: () => void;
};

const allGraphics: Record<
  string,
  (props: React.SVGProps<SVGSVGElement>) => JSX.Element | any
> = {
  graphicInputChecked: IconInputChecked,
  graphicHomeBanner: ImageHomeBanner,
  graphic404: ImageNotFound,
  graphic500: ImageErrorBoundary,
  graphicCloudBg: ImageCloudBg,
  graphicTooltipSolidBg: ImageTooltipSolidBg,
  graphicTooltipOutlineBg: ImageTooltipOutlineBg,
};

function Graphic({ id, ...rest }: GraphicProps) {
  const SelectedGraphic = allGraphics[id];
  return SelectedGraphic ? <SelectedGraphic id={id} {...rest} /> : null;
}

Graphic.defaultProps = {
  className: '',
  onClick: () => false,
};

export default Graphic;
